import {
  ButtonTracking,
  ScreenTracking,
  SCREEN_ASSET_ID
} from '../../../domain/amplitude'
import { PERSONAL_SCREEN } from '../PersonalInformation/types'

export type AlmostThereComponentProps = {
  formData: AlmostThereFormValues
  navigateStep: (step?: number) => void
  setFormData: (data: AlmostThereFormValues) => void
  error: string | null
}

export type AlmostThereFormValues = {
  promoCode: string
  legalName: string
  email: string
  primaryPhone: string
  annualIncome: number
  address: string
  dob: string
  ssn: string
  kycConfirmation: boolean
}

export type AlmostThereComponentState = AlmostThereFormValues & {
  validationErrors: Record<string, string>
}

export const ALMOST_SCREEN = 'application_submit'

export const AlmostScreenOpened: ScreenTracking = {
  asset_id: SCREEN_ASSET_ID,
  from_screen: PERSONAL_SCREEN,
  heading: 'Almost There!',
  screen: ALMOST_SCREEN
}

export const AlmostNextButton: ButtonTracking = {
  asset_id: 'applyButton',
  asset_text: 'APPLY',
  screen: ALMOST_SCREEN
}
